<template>
  <div class="home-page">
    <!-- Banner 区域 -->
    <div class="banner">
      <div class="banner-content">
        <h1>Give your <span>DREAMS</span> a Chance</h1>
      </div>
    </div>

    <!-- 快速链接区域 -->
    <div class="quick-links">
      <router-link to="/about/news" class="quick-link">
        <img :src="require('../assets/images/' + 'ppt-1.jpg')" alt="Latest News">
        <div class="link-title">Latest News</div>
      </router-link>
      <router-link to="/about/responsible-play-program" class="quick-link">
        <img :src="require('../assets/images/' + 'ppt-2.jpg')" alt="Responsible Play">
        <div class="link-title">Responsible Play</div>
      </router-link>
      <router-link to="/about/giving-back" class="quick-link">
        <img :src="require('@/assets/images/ppt-3.jpg')" alt="Giving Back">
        <div class="link-title">Giving Back</div>
      </router-link>
    </div>

    <!-- 最新开奖结果区域 -->
    <div class="latest-results">
      <div class="section-header">
        <h2>Latest Results</h2>
        <div class="order-info">Number Order: Drawn</div>
      </div>

      <div class="games-results">
        <!-- Game Results Loop -->
        <div v-for="game in games" :key="game.id" class="game-result">
          <div class="game-info">
            <img :src="require('@/assets/images/' + game.image)" :alt="game.name" class="game-logo">
            <div class="draw-details" v-if="game.results">
              <div class="draw-time">{{ formatDate(game.results.lastResult && game.results.lastResult.Date) }}</div>
              <div class="draw-number">Draw: {{ game.results.lastResult && game.results.lastResult.GameID }}</div>
            </div>
            <div class="draw-details" v-else>
              <div class="draw-time">Loading...</div>
              <div class="draw-number">Please wait</div>
            </div>
            <div class="next-draw" v-if="game.results">
              <div class="next-draw-info">Next Draw: {{ game.results.nextIssue }}</div>
              <div class="countdown">{{ countdown[game.id] || '00:00' }}</div>
            </div>
            <div class="next-draw" v-else>
              <div class="next-draw-info">Next Draw: Loading...</div>
              <div class="countdown">--:--</div>
            </div>
          </div>
          
          <!-- Render balls differently based on game type -->
          <div class="balls-container" v-if="game.results && game.results.lastResult">
            <!-- For Lucky 20 Ball (has more numbers, use smaller balls) -->
            <template v-if="game.id === 1507">
              <ball 
                v-for="(num, index) in formatDrawNumbers(game.results.lastResult.GameValue, game.id)"
                :key="index"
                :number="num"
                :color="game.color"
                size="small" />
            </template>
            <!-- For all other games -->
            <template v-else>
              <ball 
                v-for="(num, index) in formatDrawNumbers(game.results.lastResult.GameValue, game.id)"
                :key="index"
                :number="num"
                :color="game.color" />
            </template>
          </div>
          <div class="balls-container loading-balls" v-else>
            <div class="loading-message">Loading results...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ball from '@/components/shared/Ball'
import axios from 'axios'
// 创建axios实例并设置基础URL
var apiClient = axios.create({
  baseURL: '/'
});
import api from '@/services/api'
export default {
  name: 'Home',
  components: {
    Ball
  },
  data() {
    return {
      games: [
        { id: 1504, name: 'Lucky 5 Ball', image: 'ball5_new.png', color: '#e95455', results: null, loading: false },
        { id: 1506, name: 'Lucky 8 Ball', image: 'ball8.png', color: '#00a0e9', results: null, loading: false },
        { id: 1505, name: 'Lucky 10 Ball', image: 'ball10.png', color: '#ffa200', results: null, loading: false },
        { id: 1507, name: 'Lucky 20 Ball', image: 'ball20.png', color: '#8dc21f', results: null, loading: false }
      ],
      countdown: {},
      countdownIntervals: {}
    }
  },
  methods: {
    fetchResults(game) {
      game.loading = true;
      
      api.getLastResult(game.id)
        .then(response => {
          if (response.data) {
            game.results = response.data;
            
            // Start countdown timer
            this.startCountdown(game.id, response.data.secondsLeft);
          }
        })
        .catch(error => {
          console.error('Error fetching results for ' + game.name + ':', error);
        })
        .finally(() => {
          game.loading = false;
        });
    },
    formatDrawNumbers(gameValue, gameId) {
      if (!gameValue) return [];
      
      // Split the comma-separated numbers
      return gameValue.split(',').map(num => parseInt(num, 10));
    },
    formatDate(dateStr, gameId) {
      if (!dateStr) return '';
      
      var date = new Date(dateStr);
      
      // Format: Wednesday, Apr 23, 2025 05:19 am (ACST)
      var options = { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric',
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true
      };
      
      return date.toLocaleDateString('en-US', options) + ' (ACST)';
    },
    startCountdown(gameId, seconds) {
      // Clear existing interval if any
      if (this.countdownIntervals[gameId]) {
        clearInterval(this.countdownIntervals[gameId]);
      }
      
      // Set initial countdown value
      this.$set(this.countdown, gameId, this.formatCountdown(seconds));
      
      // Start interval
      this.countdownIntervals[gameId] = setInterval(() => {
        seconds--;
        
        if (seconds <= 0) {
          // Time is up, refetch results
          clearInterval(this.countdownIntervals[gameId]);
          this.fetchResults(this.games.find(g => g.id === gameId));
        } else {
          // Update countdown
          this.$set(this.countdown, gameId, this.formatCountdown(seconds));
        }
      }, 1000);
    },
    formatCountdown(seconds) {
      var minutes = Math.floor(seconds / 60);
      var remainingSeconds = seconds % 60;
      
      // 替换padStart方法
      var minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
      var secondsStr = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds.toString();
      
      return minutesStr + ':' + secondsStr;
    }
  },
  mounted() {
    // Fetch results for all games when component mounts
    var self = this;
    this.games.forEach(function(game) {
      self.fetchResults(game);
    });
  },
  beforeDestroy() {
    // Clear all intervals when component is destroyed
    var intervals = this.countdownIntervals;
    Object.keys(intervals).forEach(function(key) {
      clearInterval(intervals[key]);
    });
  }
}
</script>

<style scoped>
.home-page {
  width: 100%;
}

.banner {
  background: url('~@/assets/images/banner-bg.jpg') center/cover;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(255,255,255,0.8) 0%, rgba(76,175,80,0.6) 100%);
}

.banner-content {
  position: relative;
  z-index: 1;
}

.banner h1 {
  font-size: 64px;
  color: #333;
  font-weight: 300;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.banner h1 span {
  font-weight: 700;
  color: #4caf50;
}

.quick-links {
  max-width: 1200px;
  margin: -60px auto 60px;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  position: relative;
  z-index: 2;
}

.quick-link {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s;
}

.quick-link:hover {
  transform: translateY(-5px);
}

.quick-link img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.link-title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  color: white;
  font-size: 24px;
  font-weight: 500;
}

.latest-results {
  max-width: 1200px;
  margin: 0 auto 60px;
  padding: 0 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 3px solid #f8e483;
  padding-bottom: 15px;
}

.section-header h2 {
  font-size: 28px;
  color: #333;
}

.order-info {
  color: #666;
  font-size: 14px;
}

.game-result {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  margin-bottom: 20px;
}

.game-info {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;
}

.game-logo {
  width: 60px;
  height: 60px;
}

.draw-details {
  color: #666;
}

.draw-time {
  font-size: 14px;
  margin-bottom: 5px;
}

.draw-number {
  font-size: 14px;
  color: #999;
}

.next-draw {
  text-align: right;
}

.next-draw-info {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.countdown {
  font-size: 24px;
  color: #333;
  font-weight: bold;
}

.balls-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.loading-balls {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.loading-message {
  color: #666;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.loading-message:after {
  content: "...";
  width: 24px;
  text-align: left;
  animation: loading 1.5s infinite steps(4);
  display: inline-block;
  vertical-align: bottom;
  overflow: hidden;
}

@keyframes loading {
  0% { width: 0; }
  100% { width: 24px; }
}

@media (max-width: 768px) {
  .quick-links {
    grid-template-columns: 1fr;
    margin-top: 30px;
  }

  .banner h1 {
    font-size: 36px;
  }

  .game-info {
    grid-template-columns: auto 1fr;
  }

  .next-draw {
    grid-column: 1 / -1;
    text-align: left;
    margin-top: 10px;
  }
  
  .banner {
    height: 300px;
  }
  
  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .order-info {
    margin-top: 10px;
  }
}

@media (max-width: 576px) {
  .banner {
    height: 200px;
  }
  
  .banner h1 {
    font-size: 28px;
  }
  
  .quick-links {
    margin-top: 20px;
    margin-bottom: 40px;
    gap: 20px;
  }
  
  .quick-link img {
    height: 150px;
  }
  
  .link-title {
    padding: 15px;
    font-size: 20px;
  }
  
  .game-result {
    padding: 15px;
  }
  
  .game-logo {
    width: 50px;
    height: 50px;
  }
  
  .game-info {
    gap: 10px;
    margin-bottom: 15px;
  }
  
  .balls-container {
    gap: 7px;
  }
  
  .countdown {
    font-size: 20px;
  }
  
  .section-header h2 {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue